<div class="btn-group capture-fixture-group" [class.btn-group-sm]="size === 'sm'" dropdown [dropup]="dropup" container="body" (click)="$event.stopPropagation()">
  <button
    type="button"
    class="btn btn-outline-secondary text-nowrap"
    [class.btn-sm]="size === 'sm'"
    [class.btn-xs]="size === 'xs'"
    [disabled]="capturing || !proResultId"
    (click)="capture('gateway', $event)"
    title="Store this assessment as an anonymized E2E replay fixture (no name/email — answers only). Default: gateway suite."
  >
    <span *ngIf="capturing" class="spinner-border spinner-border-sm me-1"></span>
    <em *ngIf="!capturing" class="bi bi-clipboard2-check" [class.me-1]="!iconOnly"></em>
    <span *ngIf="!iconOnly">E2E fixture</span>
  </button>
  <button
    type="button"
    dropdownToggle
    class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split"
    [class.btn-sm]="size === 'sm'"
    [class.btn-xs]="size === 'xs'"
    [disabled]="capturing || !proResultId"
  >
    <span class="caret"></span>
    <span class="sr-only visually-hidden">Choose suite</span>
  </button>
  <ul *dropdownMenu class="dropdown-menu" role="menu">
    <li class="dropdown-header">Capture this assessment into…</li>
    <li role="menuitem" *ngFor="let suite of suites">
      <a class="dropdown-item" (click)="capture(suite.id, $event)">{{ suite.name }}</a>
    </li>
  </ul>
</div>
